import { Component } from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="bg-card border-destructive/30">
          <CardContent className="py-8 text-center space-y-3">
            <p className="text-destructive font-medium">Error al renderizar contenido</p>
            <p className="text-sm text-muted-foreground">
              {this.state.error?.message || "Un template o contenido causó un error de renderizado."}
            </p>
            <Button
              variant="outline"
              size="sm"
              onClick={() => this.setState({ hasError: false, error: null })}
              data-testid="error-boundary-retry"
            >
              Reintentar
            </Button>
          </CardContent>
        </Card>
      );
    }
    return this.props.children;
  }
}
